import { get } from "helpers/api_helper"

export const getLeaderboardDetails = async () => {
  const response = await get("/leaderboards/management")
  if (!response?.data?.publication?.status || !response?.data?.schedule?.status) {
    throw new Error("Invalid ranking information")
  }
  return response
}
